'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Now we can finally style our components based on the width of the container of the component
 * as opposed to the width of the viewport. For now we have one-step granularity, but we could always
 * add state values for more tablet and mobile size.
 *
 * The only requirement when using this mixin is that you give the outermost wrapper of the component
 * a ref of 'container'. Everything else will work automatically.
 */

exports.default = {
	// this state IS merged with other properties from other getInitialState calls
	// http://stackoverflow.com/a/23874158
	getInitialState: function getInitialState() {
		return {
			responsiveMixin: {
				isSmall: false,
				eventHandler: function () {
					// need to put the handler here, so I can remove it on unmount
					var isSmall = this.refs.container.offsetWidth < 450;
					// for efficiency, only re-render if isSmall would change
					if (this.state.responsiveMixin.isSmall !== isSmall) {
						this.setState({
							responsiveMixin: _extends({}, this.state.responsiveMixin, {
								isSmall: isSmall
							})
						});
					}
				}.bind(this)
			}
		};
	},


	// calls to all lifecycle events do not plow other declarations of same life cycle
	// methods - they are all run sequentially when that lifecycle event occurs.
	componentDidMount: function componentDidMount() {
		// when the page loads, set the "initial" isSmall value
		var isSmall = this.refs.container.offsetWidth < 450;
		this.setState({ // eslint-disable-line react/no-did-mount-set-state
			responsiveMixin: _extends({}, this.state.responsiveMixin, {
				isSmall: isSmall
			})
		});

		// check the wrapper size, and start checking when the window changes
		window.addEventListener('resize', this.state.responsiveMixin.eventHandler);
	},
	componentWillUnmount: function componentWillUnmount() {
		window.removeEventListener('resize', this.state.responsiveMixin.eventHandler);
	}
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/util/responsiveMixin.js
// module id = 448
// module chunks = 5